/** @import modules */

import { useTranslation }           from "react-i18next";

import { Link }                     from "react-router-dom";

/** @import components */

import Breadcrumbs                  from "../../../Components/Layout/Header/Breadcrumbs";

import CheckoutLayout               from "../../../Components/Orders/Checkout/Layout";

/** @import icons */

import { MdOutlineCancel } from "react-icons/md";

const TransactionFailed = () => { const { t } = useTranslation ();

    /** @returns */

    return ( <div className="container max-content-width">

        <Breadcrumbs collection={ [

            { name: t ( "checkout" ), URI: "/orders/checkout" },

            { name: t ( "transaction_error" ), URI: "#" }

        ] } type="basic" />

        <CheckoutLayout title={ t ( "checkout" ) }>

            <div className="receipt">

                <div className="title">
                    
                    <h2>

                        { t ( "transaction_error" ) }

                    </h2>
                    
                </div>

                <div className="message failed">

                    <div className="icon failed">

                        <MdOutlineCancel />

                    </div>
                    
                    <p>{ t ( "transaction_error_message" ) }</p>
                    
                </div>

                <div className="action">
                    
                    <Link to="/orders/checkout">

                        { t ( "return_to_checkout" ) }

                    </Link>
                    
                </div>

            </div>

        </CheckoutLayout>
        
    </div> );

}

/** @exports TransactionFailed */
 
export default TransactionFailed;